/* 🤖 this file was generated by svg-to-ts */
export const iconRangeBhn: {
  name: 'range_bhn';
  data: string;
} = {
  name: 'range_bhn',
  data: `<svg width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><path d="M8 0c3.308 0 6 2.691 6 6a5.945 5.945 0 0 1-2 4.472V15a1.001 1.001 0 0 1-1.555.832L8 14.202l-2.446 1.63A1 1 0 0 1 4 15v-4.528A5.94 5.94 0 0 1 2 6c0-3.309 2.691-6 6-6Zm0 2C5.794 2 4 3.794 4 6c0 1.265.579 2.429 1.589 3.192l.035.027c.269.215.398.537.376.854v3.059l1.445-.964A.99.99 0 0 1 8 12a.99.99 0 0 1 .554.168l1.446.964V10c0-.315.148-.611.399-.8A3.971 3.971 0 0 0 12 6c0-2.206-1.795-4-4-4Zm0 1a3 3 0 1 1 0 6 3 3 0 0 1 0-6Zm0 2a1.001 1.001 0 0 0 0 2 1.001 1.001 0 0 0 0-2Z"/></svg>`,
};
